/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);
};

jQuery(function($) {
  //reset resizeTimer
  var resizeTimer;

  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });
  }
  /* Toggle the filtered-nav on mobile */
  /*==========================*/

  $('.mobile-filters-toggle').on('click', function(e) {
    $('.collection__filters-wrapper').show();
  });

  $('.mobile-filters-close').on('click', function(e) {
    $('.collection__filters-wrapper').hide();
  });

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

  /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
  /*==========================*/

  var supportsSVG = function() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  }
  if (!supportsSVG()) {
    $('img[src*=".svg"]').remove();
  }

  /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
  /*==========================*/

  var images = $('.article img').load(function() {
    var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
    var width = $(this).width();
    $(this).attr('src', src).attr('width', width).removeAttr('height');
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) {
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );

  /* Mobile Search Target Toggler */
  /*==========================*/
  //searchanise fallback if User agent is not a mobile device.
  if (!isMobile()) {
    $('.mobile--search__target').on('click', function() {
      $('#mobile--menu__logo-link').toggle();
      $('#mobile--menu__search').toggle();
    });
  }

  /* Menu Switcher */
  /*==========================*/
  $('header').on('click', '.header--menu__item', function() {
    var $menuItem = $(this);
    var isActive = $menuItem.hasClass('active')

    if ($menuItem.attr('id') === 'sale') {
      window.location.href = $('#sale--collection').attr('href');
      return;
    }

    $headerMenuItems = $('.header--menu__item');
    $headerMenuItems.removeClass('active');

    //toggle active class
    if (isActive) {
      $menuItem.removeClass('active');
      $headerMenuItems.show();
    } else {
      $menuItem.addClass('active');
      if (window.matchMedia("(max-width: 1200px)").matches) {
        $headerMenuItems.not('.active').hide();
      }
    }

    var menuString = "#menu--" + $(this).attr('id');
    var $menuName = $(menuString);
    if ($menuName.hasClass('menu-open')) {
      $menuName.hide().removeClass('menu-open');
    } else {
      $('.submenu').each(function(idx, el) {
        if (el.classList.contains('menu-open')) {
          $(el).hide();
          $(el).removeClass('menu-open');
        }
      });
      $menuName.show({
        complete: function() {
            $menuName.addClass('menu-open');
            $('#main').on('mouseenter', function() {
              $menuName.hide();
              $menuName.removeClass('menu-open');
              $headerMenuItems.removeClass('active');
              $headerMenuItems.show();
            });
          },
          duration: 0
      });
    }
  });

  /* Mobile Header Menu Toggler */
  $('.mobile--menu__target').on('click', function() {
	  $('.header--menu__desktop').toggle();
    $('.submenu').hide().removeClass('menu-open');
    $('.header--menu__item').removeClass('active').show();
  });

  /* Footer menu toggle */
  $('.link-list > span').on("click", function() {
     $(this).parent().find('.link-list__list').slideToggle();
  });

  $('.reviews-container').on('click', function(e) {
    $('html, body').animate({
        scrollTop: $('#shopify-product-reviews').offset().top
    }, 300);
  });

  $('.color--item').on('mouseenter', function(e) {
    $('.color-selection').text($(this).attr('title'));
    $(this).one('mouseleave', function() {
      $('.color-selection').text($('#dropdown--color select option:selected').text());
    });
  });

  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeFunction, 100);
  });

  resizeFunction();

  function resizeFunction() {
    var $columns = $('.submenu--column');
    if (window.matchMedia("(max-width: 1200px)").matches && window.matchMedia("(min-width: 860px)").matches) {
      $columns.removeClass('fourth').addClass('third');
    } else if (window.matchMedia("(max-width: 860px)").matches) {
      $columns.removeClass('fourth third').addClass('half');
    } else {
      $columns.removeClass('third half').addClass('fourth');
      $('.header--menu__desktop, .header--menu__item').show();
    };

    if (window.matchMedia("(min-width: 860px)").matches) {
      $('.collection__filters-wrapper').show();
    }
  };

  function isMobile() {
    return /iPhone|iPad/i.test(navigator.userAgent) || /Android\s[4-9]/i.test(navigator.userAgent) || /Windows Phone\s[8-9]/i.test(navigator.userAgent)
  }
});
